export default __webpack_public_path__ + "static/media/values.3762e1f3.svg";